import styled from "styled-components";

export const JBOptInReminderHeaderOuterFrameMrGreenBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-image: 
        url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_curtains_bg_png.toString()}),
        linear-gradient(177.59deg, #015536 12.03%, #05372C 27.06%, #05372C 34.15%, #05372C 37.77%);
    
    background-size: 160%;
    background-repeat: no-repeat, no-repeat;
    background-position-y: 34%;
    background-position-x: 47%;
    background-blend-mode: darken;
`;